import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'v1/etr'

const etrIssuance = new ApiCore({
	url: url
})

etrIssuance.submitAPI = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/issuetransferabledocument`, payload)
		.then(handleResponse)
		.catch(handleError);
}

etrIssuance.retry = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/issueTransferableDocument/retry`, payload)
		.then(handleResponse)
		.catch(handleError);
}

etrIssuance.retryRequest = (id) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/retry/${id}`)
		.then(handleResponse)
		.catch(handleError);
}

etrIssuance.discardRequest = (id) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/discard/${id}`)
		.then(handleResponse)
		.catch(handleError);
}

etrIssuance.validateSchema = (dataElementId) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/validate-schema/${dataElementId}`)
		.then(handleResponse)
		.catch(handleError);
}

export default etrIssuance
